/* $(document).ready(function() {
  if(jQuery('.subscription-radio').is(':checked')){
    jQuery('.4-pack').hide();
    //var varient_id_redirect = $(".varient-sub-check:eq(1)").attr('varient-id');
    //var newurl = '?variant='+varient_id_redirect;
    //history.pushState({}, null, newurl);
  }else{
    jQuery('.4-pack').show();
  }
})

$(document).ready(function() {
  jQuery('.subscription-radio').on('click', function(){
    jQuery('.4-pack').hide();
    var variant_id_redirect = $(".wetheme-custom-radio:eq(1)").attr('varient-id');
    var newurl = '?variant='+variant_id_redirect;
    history.pushState({}, null, newurl);  
    jQuery('.8-pack .swatch-element').trigger('click');

  })


  jQuery('.onetime-radio').on('click', function(){
    jQuery('.4-pack').show();
  })

}) */

document.addEventListener('DOMContentLoaded', function() {
  function updateCartCounter(itemCount) {
    document.querySelectorAll('.cart-item-count-header--quantity').forEach(function(element) {
      element.textContent = itemCount;
    });
  }

  function getShopifyCart() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        updateCartCounter(cart.item_count);
      });
  }

  function handleCartUpdated() {
    document.addEventListener('cart:updated', function() {
      getShopifyCart();
    });
  }

  function handleRebuyCartChange() {
    document.addEventListener('rebuy:cart.change', function(event) {
      let itemCount = event.detail.cart.cart.item_count;
      updateCartCounter(itemCount);
    });
  }
  
  getShopifyCart();
  handleCartUpdated();
  handleRebuyCartChange();
});
